import BackgroundAnimation from './BackgroundAnimation'

export default BackgroundAnimation
